import {
  GET_ROLE_SUCCESS,
  GET_ROLE_FAIL,
  GET_ROLE_DETAILS_SUCCESS,
  GET_ROLE_DETAILS_FAIL,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_FAIL,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAIL,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAIL,
  RESET_ROLE_STATE,
  EXPORT_ROLE_SUCCESS,
  EXPORT_ROLE_FAIL,
  RESET_ROLE_ATTACHMENT_STATE
} from "./actionTypes"

const INIT_STATE = {
  role: [],
  roleDetails: [],
  addRole: [],
  editRole: [],
  delRole: [],
  exportRole: [],
  error: [],
}

const Role = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ROLE_SUCCESS:
      return {
        ...state,
        role: action.payload,
      }

    case GET_ROLE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_ROLE_DETAILS_SUCCESS:
      return {
        ...state,
        roleDetails: action.payload,
      }

    case GET_ROLE_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_ROLE_SUCCESS:
      return {
        ...state,
        addRole: action.payload,
        roleDetails: action.payload.data,
      }

    case ADD_ROLE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        roleDetails: action.payload.data,
        editRole: action.payload,
      }

    case UPDATE_ROLE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      
    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        roleDetails: action.payload,
        delRole: action.payload,
      }

    case DELETE_ROLE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

      case EXPORT_ROLE_SUCCESS:
        return {
          ...state,
          exportRole: action.payload,
        }

      case EXPORT_ROLE_FAIL:
        return {
          ...state,
          error: action.payload,
        }
    case RESET_ROLE_STATE:
      return {
        ...state,
        addRole: [],
        editRole: [],
        delRole: [],
        exportRole: [],
        error: [],
      }
    case RESET_ROLE_ATTACHMENT_STATE:
      return {
        ...state,
        exportRole: [],
        error: [],
      }
    default:
      return state
  }
}

export default Role
